export default "__VITE_ASSET__T$taA5Te__"